export const QR_QUERY_PARAM_NAME = 'qr';
